import { ModelInterface } from '../domain-models/model.interface';

export class ExternalDomainModelChangedEventArgs {
    senderName: string;
    domainModel: ModelInterface;
}
